.aj{padding:0.5rem;}